import { Box, Grid } from '@mui/material';
import BlockComponentText from '../../../../../models/BlockComponentValues/BlockComponentText';
import Utils from '../../../../../utils/Utils';
import CloseButton from '../../../../Buttons/Close';
import EditableText from '../../../../Form/EditableText';

interface LogoHeaderContactInfoProps {
  contact: BlockComponentText;
  contactInfo: BlockComponentText;
  isEditing: boolean;
  isTemplate: boolean;
  onSaveContact: (contact: string) => void;
  onSaveContactInfo: (contactInfo: string) => void;
  onRemoveContact: () => void;
  onRemoveContactInfo: () => void;
}

const LogoHeaderContactInfo = ({
  contact, contactInfo, isEditing, isTemplate, onSaveContact, onSaveContactInfo, onRemoveContact, onRemoveContactInfo,
}: LogoHeaderContactInfoProps) => (
  <Grid container justifyContent="center" alignItems="end" direction="column">
    {contact.value && (
      <Box sx={Utils.hoverBorder(isEditing)}>
        <CloseButton
          show={isEditing}
          updateHandler={onRemoveContact}
        />
        <EditableText
          text={contact.value}
          textColor={contact.settings?.textColor}
          isEditable={isEditing && !isTemplate}
          updateHandler={(text) => onSaveContact(text)}
        />
      </Box>
    )}

    {contactInfo.value && (
      <Box sx={Utils.hoverBorder(isEditing)}>
        <CloseButton
          show={isEditing}
          updateHandler={onRemoveContactInfo}
        />

        <EditableText
          text={contactInfo.value}
          textColor={contactInfo.settings?.textColor}
          isEditable={isEditing && !isTemplate}
          updateHandler={(text) => onSaveContactInfo(text)}
        />
      </Box>
    )}
  </Grid>
);

export default LogoHeaderContactInfo;
